/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementListMailMagazineResponse } from './MailMagazineManagementListMailMagazineResponse';

export type MailMagazineManagementListMailMagazineResponseApiRespoonse = {
    data?: MailMagazineManagementListMailMagazineResponse;
    status?: MailMagazineManagementListMailMagazineResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementListMailMagazineResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

